export const locale = {
    lang: 'en',
    data: {
        ADDRESS_LIST: {
            TITLES: {
                EMPTY: 'You have not saved an address.',
            }
        }
    }
};